export const supportedLanguages = [
  'bg',
  'cs',
  'sv',
  'en',
  'fr',
  'da',
  'de',
  'el',
  'es',
  'hr',
  'hu',
  'fi',
  'it',
  'id',
  'lt',
  'nl',
  'no',
  'pl',
  'pt',
  'ro',
  'tr',
];
